module.exports = __webpack_public_path__ + "img/mayor.6ca3bd13.svg";